(function() {
  var DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  var DAY_LABELS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseJson(value, fallback) {
    if (!value) return fallback;
    try {
      var parsed = JSON.parse(value);
      return parsed == null ? fallback : parsed;
    } catch (error) {
      return fallback;
    }
  }

  function normalizeLineBreaks(value) {
    return String(value || '')
      .replace(/\\\\r\\\\n|\\\\n|\\\\r/g, '\n')
      .replace(/\\r\\n|\\n|\\r/g, '\n')
      .replace(/\r\n?|\n/g, '\n')
      .trim();
  }

  function postalAddressToString(postalAddress) {
    if (!postalAddress || typeof postalAddress !== 'object') return '';
    var line1 = postalAddress.address_1 || postalAddress.address1 || postalAddress.streetAddress || '';
    var city = postalAddress.city || postalAddress.addressLocality || '';
    var region = postalAddress.region || postalAddress.state || postalAddress.addressRegion || '';
    var postal = postalAddress.postal_code || postalAddress.postalCode || postalAddress.zip || '';
    var country = postalAddress.country || postalAddress.addressCountry || '';
    var cityLine = [city, region, postal].filter(Boolean).join(' ');
    return [line1, cityLine, country].filter(Boolean).join('\n');
  }

  function splitAddressLines(address, postalAddress) {
    var normalized = normalizeLineBreaks(address);
    if (!normalized && postalAddress) normalized = postalAddressToString(postalAddress);
    if (!normalized) return [];
    if (normalized.indexOf('\n') !== -1) {
      return normalized.split('\n').map(function(line) {
        return line.trim();
      }).filter(Boolean);
    }
    var parts = normalized.split(',').map(function(part) {
      return part.trim();
    }).filter(Boolean);
    if (parts.length <= 1) return parts;
    return [parts[0], parts.slice(1).join(', ')];
  }

  function addressText(location) {
    return splitAddressLines(location.address, location.postal_address).join(', ');
  }

  /** Strip newlines and prepend store name for Google Maps search. */
  function mapsQuery(location) {
    var name = String(location.name || '').trim();
    var addr = String(location.address || addressText(location) || '')
      .replace(/\\n/g, '')
      .replace(/\n/g, '')
      .trim();
    if (name && addr) return name + ' ' + addr;
    return name || addr;
  }

  function mapsUrl(location) {
    var query = mapsQuery(location);
    return query ? 'https://maps.google.com/?q=' + encodeURIComponent(query) : '#';
  }

  function mapEmbedUrl(location) {
    var query = '';
    if (location.lat && location.lng) query = location.lat + ',' + location.lng;
    if (!query) query = mapsQuery(location);
    return query ? 'https://maps.google.com/maps?q=' + encodeURIComponent(query) + '&z=15&output=embed' : '';
  }

  function renderAddress(lines, className) {
    if (!lines.length) return '';
    return lines.map(function(line) {
      return '<div class="' + className + '">' + escapeHtml(line) + '</div>';
    }).join('');
  }

  function telHref(phone) {
    return 'tel:' + String(phone || '').replace(/\D/g, '');
  }

  function firstArray() {
    for (var i = 0; i < arguments.length; i++) {
      if (Array.isArray(arguments[i]) && arguments[i].length) return arguments[i];
    }
    return [];
  }

  function normalizeLocation(location, fallback) {
    var source = location || {};
    var fallbackHours = fallback && Array.isArray(fallback.hours_sets) ? fallback.hours_sets : [];
    var normalized = {
      uid: source.uid || '',
      id: source.id || '',
      location_id: source.location_id || '',
      locationId: source.locationId || '',
      name: source.name || source.short_name || (fallback && (fallback.short_name || fallback.college_name)) || '',
      address: source.address || source.formatted_address || (source.postal_address ? postalAddressToString(source.postal_address) : '') || (fallback && fallback.address) || '',
      postal_address: source.postal_address || null,
      phone: source.phone || (fallback && fallback.phone) || '',
      email: source.email || (fallback && fallback.email) || '',
      lat: source.lat || source.latitude || '',
      lng: source.lng || source.longitude || '',
      hours_sets: firstArray(source.hours_sets, source.hours, fallbackHours),
      custom_hours: firstArray(source.custom_hours, source.custom_hours_sets)
    };
    DAYS.forEach(function(day) {
      normalized[day] = source[day] || '';
    });
    normalized.notes = source.notes || '';
    return normalized;
  }

  function normalizeFallback(rawFallback) {
    var fallback = rawFallback || {};
    var hoursRaw = fallback.hours_raw || fallback.hours_sets || '';
    var hours = Array.isArray(hoursRaw) ? hoursRaw : parseJson(hoursRaw, []);
    return {
      college_name: fallback.college_name || '',
      short_name: fallback.short_name || '',
      address: fallback.address || '',
      phone: fallback.phone || '',
      email: fallback.email || '',
      hours_sets: Array.isArray(hours) ? hours : [],
      custom_hours: []
    };
  }

  function normalizeLocations(locations, fallback) {
    if (Array.isArray(locations) && locations.length) {
      return locations.map(function(location, index) {
        var normalized = normalizeLocation(location, null);
        if (index === 0 && fallback) {
          if (!normalized.hours_sets.length && Array.isArray(fallback.hours_sets)) {
            normalized.hours_sets = fallback.hours_sets;
          }
          normalized.phone = normalized.phone || fallback.phone || '';
          normalized.email = normalized.email || fallback.email || '';
        }
        return normalized;
      }).filter(function(location) {
        return location.name || location.address || location.phone || location.email;
      });
    }

    var fallbackLocation = normalizeLocation({}, fallback);
    return (fallbackLocation.name || fallbackLocation.address) ? [fallbackLocation] : [];
  }

  function hasHours(set) {
    if (!set) return false;
    return DAYS.some(function(day) {
      return set[day] != null && String(set[day]).trim() !== '';
    });
  }

  function baseHoursSets(location) {
    var sets = Array.isArray(location.hours_sets) ? location.hours_sets.filter(hasHours) : [];
    if (sets.length) return sets;
    return hasHours(location) ? [location] : [];
  }

  function customHoursSets(location) {
    return Array.isArray(location.custom_hours) ? location.custom_hours.filter(hasHours) : [];
  }

  function renderHoursRows(set, classPrefix) {
    var rows = [];
    var index = 0;
    while (index < DAYS.length) {
      var time = String(set[DAYS[index]] || 'Closed').trim() || 'Closed';
      var end = index;
      while (end + 1 < DAYS.length) {
        var next = String(set[DAYS[end + 1]] || 'Closed').trim() || 'Closed';
        if (next !== time) break;
        end++;
      }
      var label = DAY_LABELS[index] === DAY_LABELS[end] ? DAY_LABELS[index] : DAY_LABELS[index] + ' - ' + DAY_LABELS[end];
      rows.push(
        '<div class="' + classPrefix + '__hours-row">' +
          '<span class="' + classPrefix + '__hours-day">' + escapeHtml(label) + '</span>' +
          '<span class="' + classPrefix + '__hours-time">' + escapeHtml(time) + '</span>' +
        '</div>'
      );
      index = end + 1;
    }

    return rows.join('');
  }

  function renderHoursGroup(set, classPrefix) {
    var rows = renderHoursRows(set, classPrefix);
    if (!rows) return '';
    var label = String(set.label || '').trim();
    var notes = String(set.notes || set.note || '').trim();
    return (
      '<div class="' + classPrefix + '__hours-group">' +
        (label ? '<h3 class="' + classPrefix + '__hours-title">' + escapeHtml(label) + '</h3>' : '') +
        rows +
        (notes ? '<div class="' + classPrefix + '__hours-note">' + escapeHtml(notes) + '</div>' : '') +
      '</div>'
    );
  }

  function renderHours(location, classPrefix) {
    var baseSets = baseHoursSets(location);
    var customSets = customHoursSets(location);
    return baseSets.map(function(set) {
      return renderHoursGroup(set, classPrefix);
    }).join('') + customSets.map(function(set) {
      return renderHoursGroup(set, classPrefix);
    }).join('');
  }

  function phoneIcon() {
    return '<svg class="cms-stores__contact-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.55 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.58a2 2 0 0 1 2.11-.45c.8.25 1.64.43 2.5.55A2 2 0 0 1 22 16.92Z" stroke="currentColor" stroke-width="2"/></svg>';
  }

  function emailIcon() {
    return '<svg class="cms-stores__contact-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 4h16v16H4V4Z" stroke="currentColor" stroke-width="2"/><path d="m4 6 8 7 8-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function pinIcon(className) {
    return '<svg class="' + className + '" viewBox="0 0 48 48" fill="none" aria-hidden="true"><path d="M40 20C40 29.986 28.922 40.386 25.202 43.598C24.8554 43.8586 24.4336 43.9995 24 43.9995C23.5664 43.9995 23.1446 43.8586 22.798 43.598C19.078 40.386 8 29.986 8 20C8 15.7565 9.68571 11.6869 12.6863 8.68629C15.6869 5.68571 19.7565 4 24 4C28.2435 4 32.3131 5.68571 35.3137 8.68629C38.3143 11.6869 40 15.7565 40 20Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 26C27.3137 26 30 23.3137 30 20C30 16.6863 27.3137 14 24 14C20.6863 14 18 16.6863 18 20C18 23.3137 20.6863 26 24 26Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function chevronIcon() {
    return '<svg class="cms-stores__detail-chevron" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function renderContactLinks(location) {
    var links = [];
    if (location.phone) {
      links.push('<a class="cms-stores__contact-link" href="' + telHref(location.phone) + '">' + phoneIcon() + '<span>' + escapeHtml(location.phone) + '</span></a>');
    }
    if (location.email) {
      links.push('<a class="cms-stores__contact-link" href="mailto:' + encodeURIComponent(String(location.email)) + '">' + emailIcon() + '<span>' + escapeHtml(location.email) + '</span></a>');
    }
    return links.join('');
  }

  function detailCardHtml(location) {
    var addressLines = splitAddressLines(location.address, location.postal_address);
    var contactLinks = renderContactLinks(location);
    var hoursHtml = renderHours(location, 'cms-stores');
    return (
      '<article class="cms-stores__detail-card">' +
        '<div class="cms-stores__detail-header">' +
          chevronIcon() +
          '<h2 class="cms-stores__detail-title">' + escapeHtml(location.name) + '</h2>' +
        '</div>' +
        '<div class="cms-stores__detail-body">' +
          (addressLines.length ? '<div class="cms-stores__address">' + renderAddress(addressLines, 'cms-stores__address-line') + '</div>' : '') +
          (hoursHtml ? '<div class="cms-stores__hours">' + hoursHtml + '</div>' : '') +
          (contactLinks ? '<div class="cms-stores__separator"></div><div class="cms-stores__contact-list">' + contactLinks + '</div>' : '') +
        '</div>' +
      '</article>'
    );
  }

  function mapCardHtml(location) {
    var addressLines = splitAddressLines(location.address, location.postal_address);
    var addressHtml = renderAddress(addressLines, 'cms-stores__address-line');
    var url = mapsUrl(location);
    var embedUrl = mapEmbedUrl(location);
    return (
      '<aside class="cms-stores__map-card">' +
        (embedUrl ? '<iframe class="cms-stores__map-iframe" loading="lazy" referrerpolicy="no-referrer-when-downgrade" src="' + embedUrl + '" title="Map - ' + escapeHtml(location.name) + '"></iframe>' : '') +
        '<div class="cms-stores__map-overlay">' +
          '<div class="cms-stores__map-inner">' +
            pinIcon('cms-stores__map-icon') +
            '<h2 class="cms-stores__map-title">' + escapeHtml(location.name) + '</h2>' +
            (addressHtml ? '<div class="cms-stores__map-address">' + addressHtml + '</div>' : '') +
            '<a class="cms-stores__map-button" href="' + url + '" target="_blank" rel="noopener">Open In Maps</a>' +
          '</div>' +
        '</div>' +
      '</aside>'
    );
  }

  function populateCard(card, location, position) {
    card.setAttribute('data-store-position', String(position));

    var name = card.querySelector('[data-card-name]');
    if (name) name.textContent = location.name || '';

    var address = card.querySelector('[data-card-address]');
    if (address) {
      var addressLines = splitAddressLines(location.address, location.postal_address);
      address.innerHTML = renderAddress(addressLines, 'cms-store-hour-card__address-line');
      address.hidden = !addressLines.length;
    }

    var hours = card.querySelector('[data-card-hours]');
    if (hours) {
      var hoursHtml = renderHours(location, 'cms-store-hour-card');
      hours.innerHTML = hoursHtml;
      hours.hidden = !hoursHtml;
    }

    var button = card.querySelector('[data-set-my-store]');
    if (button) {
      button.setAttribute('aria-label', 'Set ' + (location.name || 'this store') + ' as my store');
    }
  }

  function cardHtml(template, location, position) {
    if (!template || !template.content) return '';
    var fragment = template.content.cloneNode(true);
    var card = fragment.querySelector('[data-cms-store-hour-card]');
    if (!card) return '';
    populateCard(card, location, position);
    var wrapper = document.createElement('div');
    wrapper.appendChild(fragment);
    return wrapper.innerHTML;
  }

  function applyStoredSelection(locations) {
    var storeSelection = window.FollettStoreSelection;
    if (!storeSelection || typeof storeSelection.resolve !== 'function') return;

    var storedSelection = storeSelection.resolve(locations);
    if (!storedSelection || storedSelection.index <= 0) return;

    var selected = locations.splice(storedSelection.index, 1)[0];
    locations.unshift(selected);
  }

  function render(root, state) {
    var content = root.querySelector('[data-cms-stores-content]');
    if (!content) return;

    if (!state.locations.length) {
      content.innerHTML = '<div class="cms-stores__empty">No store information available</div>';
      return;
    }

    var selected = state.locations[0];
    var cards = state.locations.slice(1).map(function(location, offset) {
      return cardHtml(state.template, location, offset + 1);
    }).join('');

    content.innerHTML =
      '<div class="cms-stores__my-store">' +
        '<h2 class="cms-stores__section-title">My Store</h2>' +
        '<div class="cms-stores__my-store-grid">' +
          detailCardHtml(selected) +
          mapCardHtml(selected) +
        '</div>' +
      '</div>' +
      (state.locations.length > 1
        ? '<div class="cms-stores__all-locations"><h2 class="cms-stores__section-title">All Locations</h2><div class="cms-stores__locations-grid">' + cards + '</div></div>'
        : '');
  }

  function scrollToMyStore(root) {
    var title = root.querySelector('.cms-stores__my-store > .cms-stores__section-title');
    if (!title || typeof title.scrollIntoView !== 'function') return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    title.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function onCardClick(event) {
    var button = event.target.closest('[data-set-my-store]');
    if (!button) return;
    var root = event.currentTarget;
    var card = button.closest('[data-store-position]');
    if (!card || !root._cmsStoresState) return;

    var position = Number(card.getAttribute('data-store-position'));
    var state = root._cmsStoresState;
    if (!position || !state.locations[position]) return;

    var selected = state.locations[0];
    state.locations[0] = state.locations[position];
    state.locations[position] = selected;

    if (window.FollettStoreSelection) {
      window.FollettStoreSelection.select(state.locations[0]);
    }

    render(root, state);
    window.requestAnimationFrame(function() {
      scrollToMyStore(root);
    });
  }

  function initRoot(root) {
    if (root._cmsStoresInitialized) return;
    root._cmsStoresInitialized = true;

    var rawLocations = root.getAttribute('data-cstack-locations') || root.getAttribute('data-locations') || '[]';
    var rawFallback = {};
    var fallbackId = root.getAttribute('data-fallback-id');
    var fallbackEl = fallbackId ? document.getElementById(fallbackId) : null;
    if (fallbackEl && fallbackEl.textContent) rawFallback = parseJson(fallbackEl.textContent, {});

    var fallback = normalizeFallback(rawFallback);
    var parsedLocations = parseJson(rawLocations, []);
    var template = document.getElementById(root.getAttribute('data-card-template-id') || '');

    var locations = normalizeLocations(parsedLocations, fallback);
    applyStoredSelection(locations);

    root._cmsStoresState = {
      locations: locations,
      template: template
    };

    root.addEventListener('click', onCardClick);
    render(root, root._cmsStoresState);
  }

  function initAll() {
    document.querySelectorAll('[data-cms-stores]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target) {
      event.target.querySelectorAll('[data-cms-stores]').forEach(initRoot);
    }
  });

  window.addEventListener('pageshow', function(event) {
    if (!event.persisted) return;

    document.querySelectorAll('[data-cms-stores]').forEach(function(root) {
      if (!root._cmsStoresState) return;
      applyStoredSelection(root._cmsStoresState.locations);
      render(root, root._cmsStoresState);
    });
  });
})();
